var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5293 13.3119C13.5293 12.6675 14.0516 12.1452 14.696 12.1452C15.3403 12.1452 15.8626 12.6675 15.8626 13.3119V20.3119C15.8626 20.9562 15.3403 21.4785 14.696 21.4785C14.0516 21.4785 13.5293 20.9562 13.5293 20.3119V13.3119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.696 7.56228C14.0516 7.56228 13.5293 8.08461 13.5293 8.72894C13.5293 9.37328 14.0516 9.89561 14.696 9.89561C15.3403 9.89561 15.8626 9.37328 15.8626 8.72894C15.8626 8.08461 15.3403 7.56228 14.696 7.56228Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.696 2.83594C8.25264 2.83594 3.0293 8.05928 3.0293 14.5026C3.0293 20.9459 8.25264 26.1693 14.696 26.1693C21.1393 26.1693 26.3626 20.9459 26.3626 14.5026C26.3626 8.05928 21.1393 2.83594 14.696 2.83594ZM5.36263 14.5026C5.36263 19.6573 9.54131 23.8359 14.696 23.8359C19.8506 23.8359 24.0293 19.6573 24.0293 14.5026C24.0293 9.34795 19.8506 5.16927 14.696 5.16927C9.54131 5.16927 5.36263 9.34795 5.36263 14.5026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.d588fabd323a1bf42abb2eabeaf565e1.svg";
export { ForwardRef as ReactComponent };